export const ENV = 'qa';

export const BG_TEXT = ENV.toUpperCase();

export const API_URL = 'https://api.qa.gravywork.com/api'

export const API = 'https://api.qa.gravywork.com/api'



// WEBPACK FOOTER //
// ./src/settings/qa.js